import {useEffect, useState} from "react";

import PaymentComponent from "../../components/checkout/checkoutFlow/paymentComponent";
import FooterComponent from "../../components/home/FooterComponent";

import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
import {readCart} from "../../modules/checkoutHelpers";
import {sendSlackMessageTracked} from "../../models/notifications";
import {ProductsData} from "../../data/productsData";

const STRIPE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
const stripe = loadStripe(STRIPE_KEY);
const TEST_MODE = STRIPE_KEY?.startsWith("pk_test_") ?? false;

export default function PaymentPage() {

    const [options, setOptions] = useState(null)
    const [cartData, setCartData] = useState(null)


    useEffect(() => {
        if (!options) {

            readCart((currentCartData) => {
                setCartData(currentCartData)

                const customerEmail = currentCartData?.checkout_form_data?.email
                const isMonthlyFrequency = Boolean(currentCartData?.isMonthlyFrequency)
                const interval = isMonthlyFrequency ? "month" : "year"

                // Sum amount_usd (cents) across all cart line items
                const productLineItems = currentCartData?.productLineItems || []
                let totalAmountCents = 0
                for (const productLineItem of productLineItems) {
                    const productIndex = productLineItem.productIndex
                    for (const product of ProductsData) {
                        if (product.id === productIndex) {
                            totalAmountCents += isMonthlyFrequency
                                ? (product.amountMonth || 0)
                                : (product.amountAnnual || 0)
                        }
                    }
                }

                fetchOptions(customerEmail, totalAmountCents, interval)
                sendSlackMessageTracked(`3️⃣ Visitor is visiting the checkout page. Cart data: ${JSON.stringify(currentCartData)}`)
            })
        }
    }, [])


    return (
        <div>

            {
                options ?
                <Elements
                    stripe={stripe}
                    options={options}
                >
                    <PaymentComponent/>
                </Elements> :
                    skeletonScreen()
            }
            <FooterComponent/>
        </div>
    )

    function skeletonScreen() {
        return (
            <div className="p-12 m-4 sm:m-24">
                <div role="status"
                     className="space-y-8 animate-pulse md:space-y-0 md:space-x-8 rtl:space-x-reverse md:flex md:items-center">

                    <div className="w-full">
                        <div className="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-48 mb-4"></div>
                        <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[480px] mb-2.5"></div>
                        <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 mb-2.5"></div>
                        <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[440px] mb-2.5"></div>
                        <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[460px] mb-2.5"></div>
                        <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[360px]"></div>
                    </div>
                    <div
                        className="flex items-center justify-center w-full h-48 bg-gray-300 rounded-sm sm:w-96 dark:bg-gray-700">
                        <svg className="w-10 h-10 text-gray-200 dark:text-gray-600" aria-hidden="true"
                             xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 18">
                            <path
                                d="M18 0H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm-5.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm4.376 10.481A1 1 0 0 1 16 15H4a1 1 0 0 1-.895-1.447l3.5-7A1 1 0 0 1 7.468 6a.965.965 0 0 1 .9.5l2.775 4.757 1.546-1.887a1 1 0 0 1 1.618.1l2.541 4a1 1 0 0 1 .028 1.011Z"/>
                        </svg>
                    </div>
                </div>
            </div>
        )
    }


    function fetchOptions(customerEmail, amountUsd, interval) {
        const appearance = {
            theme: 'flat',
            variables: {colorPrimaryText: '#262626'}
        }

        const myHeaders = new Headers();
        myHeaders.append("accept", "application/json");
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
            customer_email: customerEmail || "notFound@pabloo.com",
            amount_usd: amountUsd,
            interval: interval,
            test_mode: TEST_MODE,
        });

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow"
        };

        fetch('https://server.pabloo.com/payments/create_payment_intent', requestOptions)
            .then((response) => response.json())
            .then((json) => {
                const client_secret = json.client_secret

                setOptions({
                    clientSecret: client_secret,
                    appearance
                })
            })
    }
}
